// @flow

import React from "react";
import styled from "styled-components";

import { Text, Flex } from "@src/common";

const UnsupportedBrowserWrapper = styled(Flex)`
  alignItems: flex-start;
  justifyContent: flex-start;
  min-height: 100vh;
`;

export default props => (
  <UnsupportedBrowserWrapper padding={4} paddingT={3} flexDirection="column">
    <Flex>
      <img
        src={require("@public/assets/images/PSHSA_Logo.svg")}
        alt="logo"
        height="48px"
      />
    </Flex>
    <Text size={4} type="book" marginV={4}>
      This assessment form is designed with a modern user experience in mind. Some features may not work as expected in your browser.
    </Text>
    <img
      src={require("@public/assets/images/unsupported_browser.svg")}
      alt="unsupportedBrowserImage"
    />
    <Text size={4} type="book" marginT={4}>
      We recommend completing the assessment on a tablet or desktop with a browser such as:
    </Text>
    <Text size={4} type="medium" marginV={1}>
      Internet Explorer 11, or newer  –  Google Chrome  –  Safari  –  Firefox
    </Text>
  </UnsupportedBrowserWrapper>
);



// WEBPACK FOOTER //
// ./src/components/Unsupported/browser.jsx